import { IAgGridNavigationOptions } from './keyboard-navigation.types';
import { KEY_CODES } from '@config/global-constants';

/**
 * Default Navigation config
 */
export const DEFAULT_NAVIGATION_OPTIONS: IAgGridNavigationOptions = {
  alwaysFindNextEditCell: false,
  treeViewMode: false,
  treeChildrenPropertyName: 'children',
  focusCellInnerElWithDebounce: false,
  isLeafRow: null,
  allowedKeys: [
    KEY_CODES.ENTER,
    KEY_CODES.TAB,
    KEY_CODES.ARROW_UP,
    KEY_CODES.ARROW_DOWN,
    KEY_CODES.ARROW_LEFT,
    KEY_CODES.ARROW_RIGHT,
    KEY_CODES.ESCAPE,
  ],
  customEditableCheck: null,
};

/**
 * Auto focus delay time (milliseconds)
 */
export const AUTO_FOCUS_DELAY = 10;
